<template>
  <div class="text-center">
    <img src="../../../../../assets/demo1.png">
    <el-button @click="closeScanner" icon="el-icon-close" class="button-close primary-color"></el-button>
    <el-button @click="drawer=true" class="button-next" type="primary">Next <i class="el-arrow-right el-icon-right"></i></el-button>
    <el-drawer
      :with-header="false"
      :append-to-body="true"
      :visible.sync="drawer"
      direction="ltr"
      size="100%"
    >
      <BarcodeScanner v-on:closeScanner="closeScanner" v-on:getScannedData="getScannedData"/>
    </el-drawer>
  </div>
</template>

<script>
import BarcodeScanner from './BarcodeScanner'
import {Button, Drawer} from 'element-ui'
export default {
  components: {
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    BarcodeScanner
  },
  data () {
    return {
      drawer: false
    }
  },
  methods: {
    closeScanner () {
      this.drawer = false
      this.$emit('closeScanner')
    },
    getScannedData (data) {
      this.drawer = false
      this.$emit('getScannedData', data)
    }
  }
}
</script>

<style scoped>
  .button-close{
    position: absolute;
    top: 0;
    right: -15px;
    background: transparent !important;
    border: none !important;
    font-size: 35px !important;
  }

  img{
    height: 100vh;
  }

  .content{
    display: inline-block;
    position: relative;
  }

  .button-next{
    position: absolute;
    border: none;
    font-size: 20px;
    background: red;
    bottom: 0;
    right: -2px;
    float: right;
  }

  .text-center{
    text-align: center;
  }

  @media screen and (min-width: 500px) {
    .button-close{
      right: -5px;
    }

    .button-next{
      bottom: 0;
      right: -5px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/UserDemo.vue